import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTable = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_9641_32469)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M29.3081 2.10107H2.66204C2.34232 2.10107 2.08398 2.35941 2.08398 2.67915V7.31303V7.31421V13.1066V18.8989V24.6913V29.3241C2.08398 29.645 2.34232 29.9033 2.66204 29.9033H29.3081C29.6279 29.9033 29.8874 29.645 29.8874 29.3241V24.6913V18.8989V13.1066V7.31421V7.31303V2.67915C29.8874 2.35941 29.6279 2.10107 29.3081 2.10107ZM28.7277 24.1121H11.3506V19.4782H28.7277V24.1121ZM28.7277 12.5274H11.3506V7.89346H28.7277V12.5274ZM3.24128 13.6858H10.1922V18.3197H3.24128V13.6858ZM3.24128 12.5274V7.89346H10.1922V12.5274H3.24128ZM28.7277 18.3197H11.3506V13.6858H28.7277V18.3197ZM3.24128 19.4782H10.1922V24.1121H3.24128V19.4782ZM3.24128 3.25838H28.7277V6.73383H3.24128V3.25838ZM3.24128 25.2706H10.1922V28.7448H3.24128V25.2706ZM11.3506 28.7448V25.2706H28.7277V28.7448H11.3506Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_9641_32469",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			fill: "white"
		})
	}) })]
});
export default SvgTable;
